export default {
    search: {
        nav: {
            subject: "搜尋結果"
        }
    }
}
